export const shortHash = (h) => (h ? `${h.slice(0, 10)}…${h.slice(-6)}` : "");

export const copyHash = (hash, setCopiedIndex, index) => {
    navigator.clipboard.writeText(`SHA-256: ${hash}`);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 2000);
  };
